import { Box, CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
const Loading = ({
  message
}: {
  message: string;
}) => {
  return <Dialog open data-sentry-element="Dialog" data-sentry-component="Loading" data-sentry-source-file="Loading.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="Loading.tsx">{message}</DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="Loading.tsx">
        <Box display="block" margin="40px auto" textAlign="center" data-sentry-element="Box" data-sentry-source-file="Loading.tsx">
          <CircularProgress size="4rem" data-sentry-element="CircularProgress" data-sentry-source-file="Loading.tsx" />
        </Box>
      </DialogContent>
    </Dialog>;
};
export default Loading;